import { Esteira } from "./esteira.model";
import { Pessoa } from "./pessoa.model";
import { Plano } from "./plano.model";
import { Processo } from "./processo.model";
import { TipoRenda } from "./tipoRenda.model";
import { WebEsteiraStatus } from "./webEsteiraStatus.model";
import { WebTipoProcesso } from "./webTipoProcesso.model";

export class WebTempTermoRequerimentoAposentadoria {
    idTermo: number;
    vlTotalBeneficio: number;
    vlSaqueAvista: number;
    vlBeneficioBruto: number;
    tipoRenda: TipoRenda;
    qtPrazoRenda: number;
    pcSaqueAvista: number;
    pcRenda: number;
    nmProtocolo: string;
    vlFatorAtuarial: number;
    dtOpcao: Date;
    webTipoProcesso: Processo;
    webEsteiraStatus: Esteira;
    pessoa: Pessoa;
    plano: Plano;
    idPerfil: number;
    icBPU: string;
    idTipoBeneficio: number;
    idTipoConta: number;
    nrBanco: string;
    nrAgencia: string;
    nrConta: string;
    vlSaldoTotal: number
}